<template>

  <div class="wrap pt-18 pb-18 md:pb-24" v-if="isAuthenticated">
      <Notification
          v-if="notification.message"
          :notification="notification.message"
          :status="notification.status"
          :snackbar="true"
          class="mb-12"
      />

      <div class="flex justify-between">
          <div class="w-1/2">
              <h1>Woordslang</h1>

              <h2 v-if="$route.meta.title">
                  {{ $route.meta.title }}
              </h2>
          </div>

          <div class="w-auto">
              <router-link v-if="$route.name !== 'AdminDashboard'" :to="{ name: 'AdminDashboard' }" class="c-button block ml-8 mb-12">
                  Terug naar dashboard
              </router-link>
          </div>
      </div>

      <router-view/>
  </div>
  
</template>

<script>
  import { mapState } from 'vuex'

  import Notification from '@/components/Notification'

  export default {
    name: 'AdminWrapper',

    computed: {
      ...mapState('admin', {
        notification: state => state.notification,
        isAuthenticated: state => state.currentUser.isAuthenticated
      })
    },

    components: {
      Notification
    }
  }
</script>
